
export const Volumes: string = "volumes"
export const Projects: string = "projects"

export type Pages = "volumes" | "projects"